import { render } from "./UploadImagesComponent.vue?vue&type=template&id=30678059&lang=true"
import script from "./UploadImagesComponent.vue?vue&type=script&lang=js"
export * from "./UploadImagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__